// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3M_nu","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3ycHY"};